module.exports = require('./helpers/bundle-url').getBundleURL('1iIZY') + "logo-dark.eefe0b7f.svg";